import React from "react";
import * as Constants from "../../consts/Constants.js";
import Axios from "axios";
import ReservationForm from "./ReservationForm";
import { formatDateDDMMYYYYT0000 } from "../../utils/DateUtils";
import ReservationTable from "./ReservationTableComponent";

import Style from "../../styles/js/StyleReservations.js";

export default function Reservation() {
  const style = Style();

  const getDefaultStartDate = () => {
    return formatDateDDMMYYYYT0000(new Date().getTime());
  };

  const getDefaultEndDate = () => {
    let now = new Date();
    let newDate = new Date(now.setMonth(now.getDate() - 14));
    return formatDateDDMMYYYYT0000(newDate.getTime());
  };

  const [state, setState] = React.useState({
    event: -1,
    shift: -1,
    startDate: getDefaultStartDate(),
    endDate: getDefaultEndDate(),
  });

  const [attendees, setAttendees] = React.useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "alert") {
      setState({ ...state, [name]: !state.alert });
    } else if (name !== "shift") {
      setState({ ...state, [name]: value, shift: -1 });
    } else {
      setState({ ...state, [name]: value });
    }
  };

  const handleSubmit = () => {
    let source = Axios.CancelToken.source();
    Axios.get(
      Constants.FINAL_URL_RESERVATIONS +
        Constants.URL_EVENTS +
        state.event +
        "/" +
        Constants.URL_SHIFT +
        "/" +
        state.shift +
        "/" +
        Constants.URL_ATTENDEES +
        "?state=0",
      {
        cancelToken: source.token,
      }
    )
      .then((response) => {
        let data = [];
        response.data.forEach((event) => {
          data.push(event);
        });
        setAttendees(data);
      })
      .catch(function () {});
    return () => source.cancel();
  };

  return (
    <div className={style.reservations}>
      <ReservationForm {...{ state, setState, handleChange, handleSubmit }} />
      <ReservationTable attendees={attendees} />
    </div>
  );
}
